import { render, staticRenderFns } from "./DatabaseComponent.vue?vue&type=template&id=7ef4558b&scoped=true"
import script from "./DatabaseComponent.vue?vue&type=script&lang=js"
export * from "./DatabaseComponent.vue?vue&type=script&lang=js"
import style0 from "./DatabaseComponent.vue?vue&type=style&index=0&id=7ef4558b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef4558b",
  null
  
)

export default component.exports